import styled from '@emotion/styled';

export const Container = styled.div`
  position: fixed;
  top: ${props => props.y}px;
  left: ${props => props.x}px;
`;
